import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
export default store => {
  return {
    path: "classeslist",
    component: withAsyncRouteLoading(() => {
      return Promise.all([
        import(
          /* webpackChunkName: "classeslist" */ "CourseSetup/modules/Module"
        ),
        import(
          /* webpackChunkName: "classeslist" */ "CourseSetup/components/CreateCourse/containers/CreateCourseModule"
        ),
        import(
          /* webpackChunkName: "classeslist" */ "CourseSetup/components/EditCourse/containers/CourseDetailsModule"
        ),
        import(
          /* webpackChunkName: "classeslist" */ "SchoolSetup/modules/SchoolSetupModule"
        ),
        import(/* webpackChunkName: "classeslist" */ "./components"),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
          importedModule4,
        ]) => {
          const courseSetupModule = importedModule0;
          const CreateCourseModule = importedModule1;
          const courseDetailsModule = importedModule2;
          const schoolSetupReducer = importedModule3.default;
          const component = importedModule4.default;
          const reducer = courseSetupModule.default;
          const key = courseSetupModule.NAME;
          injectReducer(store, {
            key,
            reducer,
          });
          injectReducer(store, {
            key: CreateCourseModule.NAME,
            reducer: CreateCourseModule.default,
          });
          injectReducer(store, {
            key: courseDetailsModule.NAME,
            reducer: courseDetailsModule.default,
          });
          injectReducer(store, {
            key: "schoolSetup",
            reducer: schoolSetupReducer,
          });
          return component;
        }
      );
      //.catch(err => {
      // throw err;
      // });
    }),
  };
};
